import React from 'react'

interface IProps {
    className?: string
    onChanged?: (e?: string) => void
    value?: string
    id?: string
    textAreaClassName?: string
    disabled?: boolean
    placeholder?: string
}

const TextArea: React.FC<IProps> = ({className, textAreaClassName, value, onChanged, id, disabled, placeholder}) => {
    return (
        <div className={`${className}`}>
            <textarea
                id={id}
                value={value}
                onChange={e => {
                    if (onChanged) {
                        onChanged(e.target.value)
                    }
                }}
                className={`border bg-white relative w-full min-h-[300px] text-body2 rounded-[5px] px-[20px] py-[30px] border-line02 resize-none ${textAreaClassName}`}
                disabled={disabled}
                placeholder={placeholder}
            />
        </div>
    )
}

export default TextArea
